<template>
  <div class="cnc-badge-dot">
    <div v-if="isShow" :class="`badge-dot ${sizeBadge[size]} ${outline ? 'badge-outline' : ''}`"/>
  </div>
</template>

<script>
export default {
  props: {
    isShow: { type: Boolean, default: true },
    outline: { type: Boolean },
    size: { type: String },
  },
  data () {
    return {
      sizeBadge: {
        'dot': 'badge-size-dot',
        'small-dot': 'badge-size-small-dot'
      }
    }
  }
}
</script>

<style lang="scss">
.cnc-badge-dot {
  .badge-dot {
    background-color: $color-primary-500;;
    border-radius: $border-radius-circle;

    &.badge-size-dot {
      width: $space-xs;
      height: $space-xs;
    }

    &.badge-size-small-dot {
      width: $space-2xs;
      height: $space-2xs;
    }

    &.badge-outline {
      outline: 2px solid $color-white;
    }
  }
}
</style>
